import MaskLoading from './mask-loading';

export default MaskLoading;
